import ReactGA from "react-ga4";
import { GOOGLE_ANALYTICS_KEY } from "./components/common/constants";
import { isProduction } from "./components/Layout/utils";

const GoogleAnalytics = () => {
    if(isProduction())
        return ReactGA.initialize(GOOGLE_ANALYTICS_KEY)
}

export default GoogleAnalytics